import styled from 'styled-components';
import { Card, Input } from '~/components';

export const ArvoreCard = styled(Card)`
  && {
    border: 1px solid #e6e8eb;
    border-radius: 8px;
    overflow: hidden;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

/**
 * Label à esquerda do input — QualWeb T17 / AccessMonitor label_02
 * aceita posição `left` ou `up` para type=text (G162).
 */
export const SearchField = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: 8px;
  width: 100%;
  max-width: 640px;
`;

export const SearchLabel = styled.label`
  flex: 0 0 auto;
  font-size: ${({ theme }) => `${13 + 2 * (theme.zoomFonte || 0)}px`};
  font-weight: 600;
  line-height: 1.3;
  color: ${({ theme }) =>
    theme.highContrast
      ? '#ffff00'
      : theme.a11y?.textPrimary || '#262626'};
`;

export const SearchTool = styled(Input)`
  flex: 1 1 240px;
  min-width: 200px;
  max-width: 480px;
`;

export const TreeSectionHeading = styled.h2`
  margin: 0 0 8px;
  font-size: ${({ theme }) => `${16 + 2 * (theme.zoomFonte || 0)}px`};
  font-weight: 600;
  line-height: 1.3;
  color: ${({ theme }) =>
    theme.highContrast
      ? '#ffff00'
      : theme.a11y?.textPrimary || '#262626'};
`;
